import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Alert from '../Alert';
import { RootStoreInterface } from '../../Store/index';
import { qav } from '../../Utils/qav';
interface Props {
    hasShareAlertVisiable?: boolean;
    hasShareAlertTitle?: string;
    pageName?: string;
    hideHasShareAlert?(): void;
    bindShare?(): void;
}

@inject((store: RootStoreInterface) => ({
    // alert 是否可见
    hasShareAlertVisiable: store.hasShare.hasShareAlertVisiable,
    // alert title
    hasShareAlertTitle: store.hasShare.hasShareAlertTitle,
    // alert 隐藏
    hideHasShareAlert: store.hasShare.hideHasShareAlert,
    bindShare: store.hasShare.bindShare,
    pageName: store.pageName
}))
@observer
class HasShareAlert extends Component<Props> {
    public onOk = () => {
        const { bindShare, hideHasShareAlert, pageName } = this.props;
        hideHasShareAlert();
        bindShare();
        qav({
            page: pageName,
            module: 'shareAlert',
            path: [{ title: '订单共享提示弹窗展示', position: '0' }],
            operType: 'click'
        });
    };

    public onCancel = () => {
        const { hideHasShareAlert } = this.props;
        hideHasShareAlert();
    };

    public render() {
        const { hasShareAlertVisiable, hasShareAlertTitle } = this.props;
        const accessLabelInfo:Object = global.orderAccessibilityLabel(global.orderAccessibilityLabelName.SHARE_ALERT)
        return (
            <Alert
                isVisible={hasShareAlertVisiable}
                onOk={()=>{
                    this.onOk()
                    this.props.onClose && this.props.onClose()
                }}
                onCancel={()=>{
                    this.onCancel()
                    this.props.onClose && this.props.onClose()
                }}
                content={hasShareAlertTitle}
                btnText="确定"
                accessLabelInfo={accessLabelInfo}
            />
        );
    }
}
export default HasShareAlert;
